export const INFORMATIONBANNER_ICONS = {
  info: '/images/info-icon.svg',
  hint: '/images/hint-icon.svg',
  subtle: '/images/hint-icon.svg',
};
